import { FillType } from '~/static/enums/components/color-input'
import { Props, VersionMigrator } from '~/utils/editor/versioning/migrators'
import { FabricV5Data } from '~/utils/editor/versioning/object'

export enum Versions {
  V1 = 1, // data has no field 'version'
  V2 = 2,
}

export type ActualVersion = BackgroundPropsV2

export interface BackgroundPropsV1 extends Props {
  width?: number
  height?: number
  borderRadius?: number
  hasBackground?: boolean
  backgroundType?: FillType
  backgroundColor?: FabricGradientOptions | string
  backgroundOpacity?: number
  border?: number
  borderColor?: string
  borderOpacity?: number
  borderDash?: boolean
  borderExists?: boolean

  data?: FabricV5Data & {
    width?: number
    height?: number
    rx?: number
    strokeWidth?: number
    strokeDashArray?: number[]
    fill?: string
  }
}

export interface BackgroundPropsV2 extends Props {
  version?: Versions
  width?: number
  height?: number
  borderRadius?: number
  hasBackground?: boolean
  backgroundType?: FillType
  backgroundColor?: FabricGradientOptions | string
  backgroundOpacity?: number
  border?: number
  borderColor?: string
  borderOpacity?: number
  borderDash?: boolean
  borderExists?: boolean
}

export const migrateBackground: VersionMigrator<BackgroundPropsV2> = (data: object) => {
  if ('version' in data && data.version === Versions.V2) {
    return data as BackgroundPropsV2
  }

  const dataV1 = data as BackgroundPropsV1

  return {
    version: Versions.V2,
    width: dataV1.width ?? dataV1.data?.width,
    height: dataV1.height ?? dataV1.data?.height,
    borderRadius: dataV1.borderRadius ?? dataV1.data?.rx,
    hasBackground: dataV1.hasBackground ?? dataV1.data?.fill !== undefined,
    borderExists: dataV1.borderExists ?? dataV1.data?.strokeWidth !== undefined,
    border: dataV1.border ?? dataV1.data?.strokeWidth,
    borderDash: dataV1.borderDash ?? (dataV1.data?.strokeDashArray?.length ?? 0) > 0,
    backgroundType: dataV1.backgroundType,
    backgroundColor: dataV1.backgroundColor,
    backgroundOpacity: dataV1.backgroundOpacity,
    borderColor: dataV1.borderColor,
    borderOpacity: dataV1.borderOpacity,
  } as BackgroundPropsV2
}
